document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-nav]');
  if (toggle && nav) toggle.addEventListener('click', () => {
    nav.classList.toggle('open');
    toggle.setAttribute('aria-expanded', nav.classList.contains('open'));
  });

  document.querySelectorAll('[data-qty-minus],[data-qty-plus]').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = document.querySelector(btn.dataset.target);
      if (!input) return;
      const value = Math.max(1, parseInt(input.value || '1', 10) + (btn.hasAttribute('data-qty-plus') ? 1 : -1));
      input.value = value;
    });
  });

  const thumbs = document.querySelectorAll('[data-product-thumb]');
  const main = document.querySelector('[data-product-main]');
  thumbs.forEach(t => t.addEventListener('click', () => {
    if (!main) return;
    main.src = t.dataset.src;
    thumbs.forEach(x => x.classList.remove('active'));
    t.classList.add('active');
  }));
});
